import { render, staticRenderFns } from "./EventApplication.vue?vue&type=template&id=ddd97e62&scoped=true"
import script from "./EventApplication.vue?vue&type=script&lang=js"
export * from "./EventApplication.vue?vue&type=script&lang=js"
import style0 from "./EventApplication.vue?vue&type=style&index=0&id=ddd97e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd97e62",
  null
  
)

export default component.exports